import { useState } from 'react';
import useClickOutside from '../../../../useClickOutside';
import moment from 'moment';
import { formatNumberWithCommas } from '../abstruct-component/FunctionRemoveCommas';
import { useSelectorCustom } from '../abstruct-component/useSelectorCustom';

export const ColumnTransactions = (translate, warning,langLocal,handleEdit) => {
    const [options, setOptions] = useState(false)
    const { currency } = useSelectorCustom();
    const [row_id, setRowId] = useState(null)
    let domNode = useClickOutside(() => {
        setOptions(false);
        setRowId(null)
    });
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,width: "5%",
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('account')}</span>, sortable: true,width: "20%",
            cell: (row) => (
                <span>{row?.account?.name}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('amount')}</span>,
            cell: (row) => (
                <span>{formatNumberWithCommas(row?.amount)} {' '} {translate(currency)}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('transaction_date')}</span>, sortable: true,
            cell: (row) => (
                <span>{moment(row['transaction_date']).format("YYYY-MM-DD")}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('transaction_type')}</span>,
            cell: (row) => (
                <span>{row?.transaction_type?.label}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('description')}</span>,
            cell: (row) => (
                <span>{row['descriptions']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row,index) => (
                <div>
                    <i className='fa fa-ellipsis-v icon_edit' onClick={() => {setOptions(!options);setRowId(index)}}  ></i>
                    {
                        options && index === row_id && (
                            <div  ref={domNode} className='div-actions shadow_main' style={langLocal === 'ar' ? { left: '20px' } : { left: '-100px' }} >
                                {/*<span onClick={(e) => handleEdit(e, row)} >{translate('edit')}</span>*/}
                                <span onClick={() => warning(row)} >{translate('cancel')}</span>
                            </div>
                        )
                    }
                </div>
            )
        }
    ]
    return {
        columns
    }
}
